import React, { useRef, useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { useHistory, useLocation } from "react-router";
import { useParams } from "react-router-dom";

import { CreateUser_initialize, UserSet, UserSet_All, CheckMiddleUserTime, CreateNewUser } from "../../stores/slices/CreateUser";
import { UserInfoGet } from "../../stores/Information";
import { passwordCheck } from "~/functions/PasswordCheck";

const CreateUser = () => {
    const history = useHistory();
    const Params = useParams();
    const dispatch = useDispatch();
    const [inputError, setInputError] = useState(false);
    const [passwordCheckError, setPasswordCheckErrorError] = useState(false);


    const informationState = useSelector((state) => state.Information);
    const CreateUserState = useSelector((state) => state.CreateUser);

    useEffect(() => {
        //ログイン済みならトップページへ
        if(informationState["organizer"]["user_login"] === true)
        {
            history.push(`/`);
            return;
        }

        dispatch(CreateUser_initialize());

        const arg = {url_id: Params['id']};
        //パラメータのトークンからID,有効期限を取得
        dispatch(CheckMiddleUserTime(arg)).then((data) => {
            console.log(data.payload.result);
            if(data.payload.result === 'OK')
            {
                dispatch(UserSet_All([data.payload.organizer]));
                dispatch(UserSet(['limit_time', data.payload.limit_time]));
            }
            else
            {
                console.log('該当ユーザー無しor有効期限切れ');
                if(data.payload.message)
                {
                    dispatch(UserSet(['message', data.payload.message]));
                }
            }
        });
    }, [Params]);

    //有効期限切れ時のアラート
    if(CreateUserState["message"])
    {
        alert(CreateUserState["message"]);
        //トップページへ
        history.push(`/`);
    }

    //登録ボタン
    const HandleSubmit = (e) => {
        e.preventDefault();

        if(inputError) return;

        //パスワードのバリデーションチェック
        const password = CreateUserState.password;
        const check = passwordCheck(password);
        setPasswordCheckErrorError(!check);
        if(!check) return;

        if(confirm('入力内容で会員登録を行います。よろしいですか？'))
        {
            //本登録処理
            dispatch(CreateNewUser(CreateUserState)).then((user_data) => {
                const result = user_data.payload.result;
                if(result === 'OK')
                {
                    alert('会員登録が完了しました。');

                    //ログイン処理
                    const arg = {login_token: user_data.payload.organizer.login_token};
                    //パラメータのログイントークンから幹事データを取得しログイン処理する
                    dispatch(UserInfoGet(arg)).then((data) => {
                        if(data.payload.data.user_login)
                        {
                            dispatch(CreateUser_initialize());
                            //ログイン処理完了済み　トップページへ
                            history.push(`/`);
                        }
                    });
                }
                else
                {
                    //NGメッセージ表示
                    alert(user_data.payload.message);
                    //トップページへ
                    history.push(`/`);
                }
            });
        }
    };

    //値変更
    const onChange = (params) => {
        const { name, value } = params;
        dispatch(UserSet([name, value]));

        if(name === "password")
        {
            setInputError(!(value === CreateUserState.password2));
            setPasswordCheckErrorError(false);
        }
        else if(name === "password2")
        {
            setInputError(!(value === CreateUserState.password));
        }
    };

    return (
        <React.Fragment>
            <Typography variant="h2" align="center">
                会員登録
            </Typography>
            {/* <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ minHeight: "100px" }} style={{ display: CreateUserState.yahoo_token ? '' : 'none' }}>
                {"Yahoo! JAPAN ID 連携中"}
            </Grid> */}
            <form onSubmit={HandleSubmit}>
                <Grid
                    container
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                    sx={{ minHeight: "300px" }}
                >
                    <Typography variant="h5" gutterBottom component="div" sx={{ mt: 3 }}>
                        メールアドレス
                    </Typography>
                    <Grid container direction="row" justifyContent="center" alignItems="center" sx={{ p: 2 }}>
                        <TextField
                            required
                            sx={{ maxWidth: "20rem", m: 1, fontSize: "1.2rem" }}
                            label="メールアドレス"
                            variant="outlined"
                            name="email_address"
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ maxLength: 60 }}
                            value={CreateUserState.email_address}
                            onChange={(e) => onChange({ name: "email_address", value: e.target.value })}
                            type="email"
                            //disabled={CreateUserState.yahoo_token ? false : true}
                            disabled
                        />
                    </Grid>
                    <Typography variant="h5" gutterBottom component="div" sx={{ mt: 3 }} style={{ display: CreateUserState.yahoo_token ? 'none' : '' }}>
                        パスワード
                    </Typography>
                    <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        sx={{ maxWidth: "350px" }}
                    >
                        {"アルファベットの大文字、小文字、数字、記号を含む、10~20字のパスワードを設定してください。"}
                        <br />
                        {"使用可能記号：! \" # $ % & ' ( ) * + , - . /"}
                    </Grid>
                    
                    <TextField
                        //required={CreateUserState.yahoo_token ? false : true}
                        required
                        sx={{ maxWidth: "20rem", m: 1, fontSize: "1.2rem" }}
                        label="パスワード　10文字以上で設定してください。"
                        variant="outlined"
                        name="password"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ minLength: 10, maxLength: 20 }}
                        value={CreateUserState.password}
                        onChange={(e) => onChange({ name: "password", value: e.target.value })}
                        type="password"
                        //style={{ display: CreateUserState.yahoo_token ? 'none' : '' }}
                        error={passwordCheckError}
                        helperText={passwordCheckError ? "アルファベットの大文字、小文字、数字、使用可能記号のみを含む、10~20字のパスワードを設定してください" : ""}
                    />
                    <TextField
                        //required={CreateUserState.yahoo_token ? false : true}
                        required
                        sx={{ maxWidth: "20rem", m: 1, fontSize: "1.2rem" }}
                        label="パスワード　確認のため再度ご入力ください。"
                        variant="outlined"
                        name="password2"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ maxLength: 20 }}
                        value={CreateUserState.password2}
                        onChange={(e) => onChange({ name: "password2", value: e.target.value })}
                        type="password"
                        error={inputError}
                        helperText={inputError ? "パスワードが一致しません" : ""}
                        //style={{ display: CreateUserState.yahoo_token ? 'none' : '' }}
                    />

                    <Typography variant="h5" gutterBottom component="div" sx={{ mt: 3 }}>
                        業務上氏名
                    </Typography>
                    <TextField
                        required
                        sx={{ maxWidth: "20rem", m: 1, fontSize: "1.2rem" }}
                        label="業務上氏名"
                        variant="outlined"
                        name="business_name"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ maxLength: 16 }}
                        value={CreateUserState.business_name}
                        onChange={(e) => onChange({ name: "business_name", value: e.target.value })}
                    />

                    <Typography variant="h5" gutterBottom component="div" sx={{ mt: 3 }}>
                        業務上アカウント
                    </Typography>
                    <TextField
                        required
                        sx={{ maxWidth: "20rem", m: 1, fontSize: "1.2rem" }}
                        label="業務上アカウント"
                        variant="outlined"
                        name="business_account"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ maxLength: 60 }}
                        value={CreateUserState.business_account}
                        onChange={(e) => onChange({ name: "business_account", value: e.target.value })}
                    />
                </Grid>
                <Grid container direction="row" justifyContent="center" alignItems="center" sx={{ mb: 3 }}>
                    <Button variant="contained" type="submit" fullWidth sx={{ maxWidth: "10rem" }}>
                        登録
                    </Button>
                </Grid>
            </form>
        </React.Fragment>
    );
};

export default CreateUser;
